export const OTP_LENGTH = 4;
export const MAX_OTP_SEND_ATTEMPTS = 3;
export const MESSAGEBOX_TYPE = {
    ERROR: 'error',
    WARNING: 'warning',
};
